<template>
    <div class="spotlight-result-item" :class="{ 'spotlight-result-item--focused': focused }" @click="$emit('select', item)">
        <div class="spotlight-result-icon spotlight-result-icon--stock">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
        </div>
        <div class="spotlight-result-text">
            <div class="spotlight-result-title">{{ item.title }}</div>
            <div v-if="item.subtitle" class="spotlight-result-subtitle">{{ item.subtitle }}</div>
        </div>
        <div class="spotlight-result-meta">
            <span v-if="item.meta && item.meta.price" class="spotlight-result-badge">{{ item.meta.price }}</span>
            <span v-if="item.meta && item.meta.total_quantity != null" class="spotlight-stock-qty">{{ $t('common.spotlight.stockQty', { count: item.meta.total_quantity }) }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StockResult',
    props: { item: Object, focused: Boolean },
    emits: ['select']
}
</script>
